import React from 'react';
import { Item } from '../../../../../containers/commerce';
import { Col } from '../../../../grid';
import PalleItem from '../../../Item/PalleItem';

const RenderPallePricePrPiece = ({
  palleItem,
}) => {
  if (!palleItem) {
    return null;
  }
  return (
    <Col xs={12} paddingTop="0px" paddingBottom="0px">
      <Item
        varenr={palleItem}
        display={PalleItem}
      />
    </Col>
  );
};

export default RenderPallePricePrPiece;
